module.exports = __webpack_public_path__ + "static/ocelli-charlie.cb6cf190.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ocelli-charlie.png
// module id = 432
// module chunks = 35783957827783